import React, { useState } from "react";
import { supabase } from "../lib/supabaseClient";

const QuickAdd = () => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const searchFood = async () => {
    if (!query.trim()) return;

    setLoading(true);

    const { data, error } = await supabase
      .from("food_database")   // ← EXACT TABLE NAME
      .select("id, name, calories, protein, carbs, fat, fiber, serving_size")
      .ilike("name", `%${query}%`)
      .limit(30);

    setLoading(false);

    if (error) {
      
      alert("Error searching foods");
      return;
    }

    setResults(data);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-xl mx-auto">
        <h1 className="text-2xl font-bold mb-4">Quick Add Food</h1>

        {/* Search Bar */}
        <div className="flex gap-2 mb-6">
          <input
            type="text"
            placeholder="Search food (e.g., Idli, Paneer, Egg)"
            className="w-full border p-3 rounded-xl"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />

          <button
            onClick={searchFood}
            className="px-4 py-2 bg-emerald-600 text-white rounded-xl"
          >
            Search
          </button>
        </div>

        {loading && <p>Searching...</p>}

        {/* Results */}
        <div className="space-y-4">
          {results.map((food) => (
            <div
              key={food.id}
              className="bg-white p-4 border rounded-2xl shadow-md"
            >
              <p className="text-lg font-semibold">{food.name}</p>

              <div className="text-sm text-gray-600 mt-2 space-y-1">
                <p>Calories: {food.calories}Kcal</p>
                <p>Protein: {food.protein}g</p>
                <p>Carbs: {food.carbs}g</p>
                <p>Fat: {food.fat}g</p>
                <p>Fiber: {food.fiber}g</p>
                <p>Serving: {food.serving_size}</p>
              </div>

              <button className="mt-3 px-4 py-2 bg-emerald-500 text-white rounded-lg">
                Add to Meal
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickAdd;
